
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Menschen mit chronischem Schlaf­mangel aber auch Schichtarbeiter haben ein erhöhtes Risiko dick zu werden, eine Adipositas oder einen Typ 2-Diabetes zu entwickeln. Auch eine Diät zeigt weniger Erfolg, wenn zu wenig geschlafen wird, wenn die Schlafdauer von 8,5 Stunden auf 5,5 Stunden gesenkt wird. Aber nicht nur auf längere Sicht, kann dieser Fakt bewiesen werden. Bereits schon eine durchwachte Nacht führt dazu, dass der Körper weniger Fett abbaut und Muskelproteine abbaut. Jonathan Cedernaes von der Universität Uppsala und sein Team haben in einer randomisierten Studie bewiesen,  ???`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;